import ChevronUpIcon from "@svg/explore/checvron-up";
import classNames from "classnames";
import useExplorePreloadedData from "@templates/new-explore/hooks/useExplorePreloadedData";
import { useRouter } from "next/router";
import { hasNonSharedExploreFilters } from "@modules/new-explore/schema";
import Accordion from "legacy/elements/accordion";

const ExploreFilters = () => {
  const { filtersData } = useExplorePreloadedData();
  const { query } = useRouter();
  const hideSlugChanger = hasNonSharedExploreFilters(query);

  if (!filtersData) return <></>;
  const filterLength = Object.entries(filtersData).length;
  return (
    <>
      {Object.entries(filtersData).map(
        (
          [filterName, { active, desktopComponent, label, inAccordian }],
          index
        ) => {
          const FilterComponent = desktopComponent;
          if (!FilterComponent) return null;
          if (filterName === "slug" && hideSlugChanger) return null;

          return (
            <div
              key={filterName}
              className={classNames(
                " w-full  pl-2 [&:has(>:empty)]:hidden",
                index !== filterLength - 1 && "border-b border-fds-divider"
              )}
            >
              {inAccordian ? (
                <Accordion
                  title={label}
                  open={active}
                  titleClassName="!title-md-demibold"
                  iconComponent={(isOpen) => (
                    <ChevronUpIcon
                      className={classNames(isOpen ? "" : "rotate-180")}
                    />
                  )}
                  className={(open) =>
                    `mt-3.5   h-max ${open ? "mb-3" : "mb-3.5"} `
                  }
                >
                  <div className="w-full mb-4">
                    <FilterComponent />
                  </div>
                </Accordion>
              ) : (
                <div className="w-full py-3.5 empty:hidden">
                  <FilterComponent />
                </div>
              )}
            </div>
          );
        }
      )}
    </>
  );
};

export default ExploreFilters;
